import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnion = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 17",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 0.5C5.3208 0.5 3.2881 1.37835 1.9335 2.88268C0.591744 4.37277 0 6.38278 0 8.5C0 10.6152 0.584656 12.6256 1.92382 14.1166C3.27616 15.6222 5.30982 16.5 8 16.5C10.692 16.5 12.7253 15.615 14.0768 14.1069C15.4149 12.6137 16 10.6041 16 8.5H14.4C14.4 10.3239 13.8931 11.9143 12.8852 13.0391C11.8907 14.149 10.324 14.9 8 14.9C5.67418 14.9 4.10784 14.1538 3.11418 13.0474C2.10734 11.9264 1.6 10.3368 1.6 8.5C1.6 6.66522 2.11226 5.07523 3.1225 3.95331C4.1199 2.84565 5.6872 2.1 8 2.1V0.5ZM8.58399 9.63931L15.3737 2.84962L14.2423 1.71825L8.58399 7.37656L5.75769 4.55026L4.6263 5.68162L8.58399 9.63931Z"
	})]
});
const ForwardRef = forwardRef(SvgUnion);
export default ForwardRef;
